<script setup>
import { computed } from 'vue';
import ContactPanel from 'dashboard/routes/dashboard/conversation/ContactPanel.vue';
import ContentTemplatesPanel from './ContentTemplatesPanel.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useWindowSize } from '@vueuse/core';
import { vOnClickOutside } from '@vueuse/components';
import wootConstants from 'dashboard/constants/globals';

defineProps({
  currentChat: {
    required: true,
    type: Object,
  },
});

const { uiSettings, updateUISettings } = useUISettings();
const { width: windowWidth } = useWindowSize();

// 0 = contact, 1 = templates, null = hidden
const activeTab = computed(() => {
  const {
    is_contact_sidebar_open: isContactSidebarOpen,
    is_templates_panel_open: isTemplatesPanelOpen,
  } = uiSettings.value;

  if (isContactSidebarOpen) return 0;
  if (isTemplatesPanelOpen) return 1;
  return null;
});

const isSmallScreen = computed(
  () => windowWidth.value < wootConstants.SMALL_SCREEN_BREAKPOINT
);

const closePanels = () => {
  if (isSmallScreen.value && activeTab.value !== null) {
    updateUISettings({
      is_contact_sidebar_open: false,
      is_copilot_panel_open: false,
      is_templates_panel_open: false,
    });
  }
};

const closeTemplatesPanel = () => {
  updateUISettings({ is_templates_panel_open: false });
};
</script>

<template>
  <div
    v-on-click-outside="[
      () => closePanels(),
      {
        ignore: [
          'dialog.ProseMirror-prompt-backdrop',
          '[data-popover-content]',
          '[data-popover-backdrop]',
        ],
      },
    ]"
    class="bg-n-surface-2 h-full overflow-hidden flex flex-col fixed top-0 z-40 w-full max-w-sm transition-transform duration-300 ease-in-out ltr:right-0 rtl:left-0 md:static md:w-[320px] md:min-w-[320px] ltr:border-l rtl:border-r border-n-weak 2xl:min-w-[360px] 2xl:w-[360px] shadow-lg md:shadow-none"
    :class="[
      {
        'md:flex': activeTab !== null,
        'md:hidden': activeTab === null,
      },
    ]"
  >
    <div class="flex flex-1 overflow-auto">
      <ContactPanel
        v-show="activeTab === 0"
        :conversation-id="currentChat.id"
        :inbox-id="currentChat.inbox_id"
      />
      <ContentTemplatesPanel
        v-show="activeTab === 1"
        data-zoho-tour="templates-panel-content"
        @close="closeTemplatesPanel"
      />
    </div>
  </div>
</template>
